import type { TabType } from 'app/components/ui/nav-tabs'

const enum Sections {
  PMS_REFERRAL = `pms-referral`,
  CDT_CODES = `cdt-codes`,
  FORMS = `forms`,
}

const tabs: TabType[] = [
  { name: `PMS Referral`, href: Sections.PMS_REFERRAL },
  { name: `CDT Codes`, href: Sections.CDT_CODES },
  { name: `Forms`, href: Sections.FORMS },
]

export type UseReferralTypesLayoutReturn = {
  title: string
  tabs: TabType[]
}

export function useReferralTypesLayout(): UseReferralTypesLayoutReturn {
  return {
    title: `Referral Type Mapping`,
    tabs,
  }
}
